// Footer.jsx
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
    FaMapMarkerAlt,
    FaPhone,
    FaEnvelope,
    FaClock,
    FaFacebookF,
    FaTwitter,
    FaLinkedinIn,
    FaYoutube,
    FaInstagram,
    FaGlobe,
    FaChevronRight,
    FaPaperPlane,
    FaShieldAlt,
    FaCertificate,
    FaRegBuilding
} from 'react-icons/fa';
import { SiGooglemaps } from 'react-icons/si';

const Footer = () => {
    const [email, setEmail] = useState('');
    const [subscriptionStatus, setSubscriptionStatus] = useState('');

    const themeColor = "rgb(43 147 208)";
    const themeColorDark = "rgb(32 110 156)";
    const themeColorLight = "rgba(43, 147, 208, 0.1)";

    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email) {
            setSubscriptionStatus('Thank you for subscribing!');
            setEmail('');
            setTimeout(() => setSubscriptionStatus(''), 3000);
        }
    };

    const quickLinks = [
        { name: "Home", href: "#" },
        { name: "About Us", href: "#" },
        { name: "Our Services", href: "#" },
        { name: "MSME Resources", href: "#" },
        { name: "Government Schemes", href: "#" },
        { name: "Events & Programs", href: "#" },

    ];

    const servicesLinks = [
        "General Services",
        "Skill Development",
        "Tech Transfer",
        "Credit & Financial",
        "Marketing Promotion",
        "Research & Policy",

    ];

    const socialLinks = [
        { icon: FaFacebookF, href: "#", color: "hover:bg-blue-600" },
        { icon: FaTwitter, href: "#", color: "hover:bg-sky-500" },
        { icon: FaLinkedinIn, href: "#", color: "hover:bg-blue-700" },
        { icon: FaYoutube, href: "#", color: "hover:bg-red-600" },
        { icon: FaInstagram, href: "#", color: "hover:bg-pink-600" }
    ];

    const certifications = [
        "ISO 9001:2015 Certified",
        "Government Recognized",
        "MSME Ministry Partner",
        "Export Promotion Council",
        "International Accreditation"
    ];

    const fadeInUp = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6 }
        }
    };

    const staggerContainer = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    };

    return (
        <footer className="relative bg-gray-900 text-white overflow-hidden">
            {/* Top Decorative Wave */}
            <div className="absolute top-0 left-0 right-0 transform translate-y-1">
                <svg viewBox="0 0 1440 120" className="w-full h-auto">
                    <path
                        fill={themeColorDark}
                        fillOpacity="0.2"
                        d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
                    />
                </svg>
            </div>

            {/* Main Footer Content */}
            <div className="relative pt-16 pb-8 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
                    {/* Left Column - Logo, About, and Contact */}
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={fadeInUp}
                    >
                        {/* Logo and About */}
                        <div className="mb-10">
                            <div className="flex items-center mb-6">
    <img 
        src="/img/WASME Logo Final White LIne.png" 
        alt="WASME Logo" 
        className="h-24 w-auto"
    />
</div>

                            <p className="text-gray-300 mb-8 leading-relaxed text-justify">
                                Since 1980, WASME is engamed in the promotion and development of MSMEs along with chambers of commerce and industry , embassies, MSMEs associations and MSMEs  across globe.
                            </p>

                            {/* Certifications Badges */}
                            {/* <div className="flex flex-wrap gap-2 mb-8">
                {certifications.map((cert, index) => (
                  <span 
                    key={index}
                    className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-800 text-blue-300"
                  >
                    <FaCertificate className="w-3 h-3 mr-1" />
                    {cert}
                  </span>
                ))}
              </div> */}
                        </div>

                        {/* Contact Information */}
                        <div className="space-y-6">
                            <h3 className="text-xl font-bold mb-6 relative inline-block">
                                Contact Information
                                <div className="absolute -bottom-2 left-0 w-12 h-1 rounded-full" style={{ backgroundColor: themeColor }}></div>
                            </h3>

                            <div className="space-y-4">
                                <div className="flex items-start">
                                    <div className="p-2 rounded-lg mr-4" style={{ backgroundColor: themeColorLight }}>
                                        <FaMapMarkerAlt className="w-5 h-5" style={{ color: themeColor }} />
                                    </div>
                                    <div>
                                        <h4 className="font-semibold mb-1">Head Office</h4>
                                        <p className="text-gray-300">
                                            WASME Film City, Sector 16A<br />
                                            Noida, Uttar Pradesh 201301<br />
                                            India
                                        </p>
                                    </div>
                                </div>

                                <div className="flex items-start">
                                    <div className="p-2 rounded-lg mr-4" style={{ backgroundColor: themeColorLight }}>
                                        <FaPhone className="w-5 h-5" style={{ color: themeColor }} />
                                    </div>
                                    <div>
                                        <h4 className="font-semibold mb-1">Phone Numbers</h4>
                                        <p className="text-gray-300">
                                            +91 120 456 7890<br />
                                            +91 120 456 7891 (Helpline)
                                        </p>
                                    </div>
                                </div>

                                <div className="flex items-start">
                                    <div className="p-2 rounded-lg mr-4" style={{ backgroundColor: themeColorLight }}>
                                        <FaEnvelope className="w-5 h-5" style={{ color: themeColor }} />
                                    </div>
                                    <div>
                                        <h4 className="font-semibold mb-1">Email Address</h4>
                                        <p className="text-gray-300">
                                            info@wasme.org<br />
                                            support@wasme.org
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>

                    {/* Right Column - Map and Links */}
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={staggerContainer}
                        className="space-y-12"
                    >
                        {/* Google Map */}
                        <div>
                            <h3 className="text-xl font-bold mb-4 relative inline-block">
                                <SiGooglemaps className="inline w-5 h-5 mr-2" />
                                Visit Our Office
                                <div className="absolute -bottom-2 left-0 w-12 h-1 rounded-full" style={{ backgroundColor: themeColor }}></div>
                            </h3>

                            <div className="relative rounded-xl overflow-hidden border-2 border-blue-800 shadow-lg hover:shadow-xl transition-shadow duration-300">
                                <div className="aspect-w-16 aspect-h-9 bg-gray-800">
                                    {/* Google Map Iframe */}
                                    <iframe
                                        title="WASME Office Location"
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.7147590048394!2d77.33473881508109!3d28.552490982450363!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5c5e2f6f7d7%3A0x7bb7e5c5e2f6f7d7!2sFilm%20City%2C%20Sector%2016A%2C%20Noida%2C%20Uttar%20Pradesh%20201301!5e0!3m2!1sen!2sin!4v1640012345678!5m2!1sen!2sin"
                                        width="100%"
                                        height="250"
                                        style={{ border: 0 }}
                                        allowFullScreen=""
                                        loading="lazy"
                                        className="rounded-lg"
                                    ></iframe>
                                </div>

        

                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
                                    <div className="flex items-center">
                                        <FaMapMarkerAlt className="w-5 h-5 text-red-500 mr-2" />
                                        <span className="text-white font-medium">WASME Film City, Sector 16A, Noida</span>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-4 flex items-center text-sm text-gray-300">
                                <FaShieldAlt className="w-4 h-4 mr-2 text-green-400" />
                                <span>Secure & verified location. Click map for directions.</span>
                            </div>
                        </div>

                        {/* Quick Links Grid */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            {/* Quick Links */}
                            <div>
                                <h3 className="text-xl font-bold mb-6 relative inline-block">
                                    Quick Links
                                    <div className="absolute -bottom-2 left-0 w-12 h-1 rounded-full" style={{ backgroundColor: themeColor }}></div>
                                </h3>
                                <ul className="space-y-3">
                                    {quickLinks.map((link, index) => (
                                        <motion.li
                                            key={index}
                                            whileHover={{ x: 5 }}
                                            className="group"
                                        >
                                            <a
                                                href={link.href}
                                                className="flex items-center text-gray-300 hover:text-white transition-colors duration-300"
                                            >
                                                <FaChevronRight className="w-3 h-3 mr-2 group-hover:text-blue-400 transition-colors duration-300" />
                                                {link.name}
                                            </a>
                                        </motion.li>
                                    ))}
                                </ul>
                            </div>

                            {/* Our Services */}
                            <div>
                                <h3 className="text-xl font-bold mb-6 relative inline-block">
                                    Our Services
                                    <div className="absolute -bottom-2 left-0 w-12 h-1 rounded-full" style={{ backgroundColor: themeColor }}></div>
                                </h3>
                                <ul className="space-y-3">
                                    {servicesLinks.map((service, index) => (
                                        <motion.li
                                            key={index}
                                            whileHover={{ x: 5 }}
                                            className="group"
                                        >
                                            <a
                                                href="#"
                                                className="flex items-center text-gray-300 hover:text-white transition-colors duration-300"
                                            >
                                                <div className="w-1.5 h-1.5 rounded-full mr-3 bg-blue-500 group-hover:bg-blue-400 transition-colors duration-300"></div>
                                                {service}
                                            </a>
                                        </motion.li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </motion.div>
                </div>

                {/* Newsletter Subscription */}
                {/* <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
          className="mb-12"
        >
          <div 
            className="rounded-xl p-8 relative overflow-hidden"
            style={{ 
              background: `linear-gradient(135deg, ${themeColor} 0%, ${themeColorDark} 100%)`
            }}
          >
            <div className="absolute top-0 right-0 opacity-10">
              <FaPaperPlane className="w-48 h-48" />
            </div>
            
            <div className="relative z-10">
              <div className="flex flex-col lg:flex-row items-center justify-between">
                <div className="mb-6 lg:mb-0 lg:mr-8">
                  <h3 className="text-2xl font-bold mb-2">Subscribe to Our Newsletter</h3>
                  <p className="text-blue-100">
                    Stay updated with the latest MSME news, government schemes, and WASME initiatives
                  </p>
                </div>
                
                <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email address"
                    className="px-6 py-3 rounded-lg text-gray-900 flex-grow sm:flex-grow-0 sm:w-80 focus:outline-none focus:ring-2 focus:ring-white"
                    required
                  />
                  <button
                    type="submit"
                    className="px-8 py-3 bg-white text-blue-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors duration-300 flex items-center justify-center"
                  >
                    <FaPaperPlane className="w-4 h-4 mr-2" />
                    Subscribe
                  </button>
                </form>
              </div>
              
              {subscriptionStatus && (
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="mt-4 p-3 bg-green-500/20 border border-green-500/30 rounded-lg text-center"
                >
                  {subscriptionStatus}
                </motion.div>
              )}
            </div>
          </div>
        </motion.div> */}

                {/* Social Links & Additional Info */}
                <div className="border-t border-gray-800 pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        {/* Social Media */}
                        <div className="mb-6 md:mb-0">
                            <h4 className="font-semibold mb-4 text-center md:text-left">Connect With Us</h4>
                            <div className="flex space-x-4">
                                {socialLinks.map((social, index) => {
                                    const Icon = social.icon;
                                    return (
                                        <motion.a
                                            key={index}
                                            href={social.href}
                                            whileHover={{ scale: 1.1, y: -3 }}
                                            whileTap={{ scale: 0.95 }}
                                            className={`w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center text-white ${social.color} transition-colors duration-300`}
                                        >
                                            <Icon className="w-4 h-4" />
                                        </motion.a>
                                    );
                                })}
                                <motion.a
                                    href="#"
                                    whileHover={{ scale: 1.1, y: -3 }}
                                    whileTap={{ scale: 0.95 }}
                                    className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center text-white hover:bg-gray-700 transition-colors duration-300"
                                    title="WASME Website"
                                >
                                    <FaGlobe className="w-4 h-4" />
                                </motion.a>
                            </div>
                        </div>






                    </div>
                </div>
            </div>

            {/* Bottom Footer Bar */}
            <div className="border-t border-gray-800">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="py-6 flex flex-col md:flex-row justify-between items-center">
                        {/* Copyright */}
                        <div className="mb-4 md:mb-0 text-center md:text-left">
                            <p className="text-gray-400 text-sm">
                                © {new Date().getFullYear()} World Association for Small and Medium Enterprises (WASME).
                                All rights reserved.
                            </p>

                        </div>

                        {/* Policies Links */}


                        {/* Developer Credit */}
                        <div className="text-center">
                            <div className="flex items-center justify-center">
                                <div className="text-gray-500 text-sm">
                                    Designed & Developed By
                                    <span className="ml-1 px-2 py-1 rounded bg-gray-800 text-blue-300 font-semibold">
                                        #Netcoreinfo
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Back to Top Button */}
            <motion.button
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="fixed bottom-8 right-8 w-12 h-12 rounded-full flex items-center justify-center shadow-lg z-50"
                style={{ backgroundColor: themeColor }}
                aria-label="Back to top"
            >
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                </svg>
            </motion.button>

            {/* Floating Elements */}
            <div className="absolute bottom-20 left-10 w-4 h-4 rounded-full opacity-10" style={{ backgroundColor: themeColor }}></div>
            <div className="absolute top-40 right-20 w-6 h-6 rounded-full opacity-10" style={{ backgroundColor: themeColor }}></div>
        </footer>
    );
};

export default Footer;